var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-layer"},[_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"go-mobile"},[_c('img',{attrs:{"src":_vm.wechat,"alt":"wechat"}}),_c('p',[_vm._v("手机扫码邀请好友")])]),_c('a',{staticClass:"btn-item btn-close",attrs:{"href":"javascript: void(0)"},on:{"click":_vm.closeRecommend}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }